import React, { SVGProps } from 'react';

function SendIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M1.3 12.0687C1.05 12.1687 0.8125 12.1469 0.5875 12.0031C0.3625 11.8594 0.25 11.65 0.25 11.375V7.99998L6.25 6.49998L0.25 4.99998V1.62498C0.25 1.34998 0.3625 1.1406 0.5875 0.996853C0.8125 0.853103 1.05 0.831228 1.3 0.931228L12.85 5.80623C13.1625 5.94373 13.3188 6.17498 13.3188 6.49998C13.3188 6.82498 13.1625 7.05623 12.85 7.19373L1.3 12.0687Z" fill="currentColor" />
    </svg>
  );
}

export default SendIcon;
